// スタンダードプラン - 時間帯テーマ（基本テーマベース + グロナビ・フッター色変更）
export const standardThemes = {
  // 🌅 モーニングカーム - 朝の清々しさ（鮮やかなコーラル系）
  morningCalm: {
    id: 'morningCalm',
    name: '🌅 タイムモーニングカーム',
    description: '清々しい朝の光で一日をスタート',
    category: 'standard',
    colors: {
      primary: 'red',        // より鮮やかなレッド
      secondary: 'slate',
      accent: 'pink',        // ピンクアクセント
      neutral: 'gray',
      // 背景色 - 鮮やかなコーラル系
      background: 'red-25',          // 薄いコーラル背景
      cardBg: 'white',
      // テキスト色
      textPrimary: 'slate-800',      // 少し濃く
      textSecondary: 'slate-600',
      // ボーダー
      border: 'red-300',             // より鮮やか
      borderLight: 'red-200',
      // ボタン - 鮮やかなコーラル
      button: 'red-500',
      buttonHover: 'red-600',
      // ヘッダー（グロナビ）- 鮮やかな色
      headerBg: 'red-500',
      headerText: 'white',
      headerHover: 'red-400/20',
      // フッター - 深いコーラル
      footerBg: 'red-700',
      footerText: 'white',
      footerLink: 'red-200'
    }
  },

  // ☀️ ミッドデイブライト - 昼の活力（鮮やかなターコイズ系）
  middayBright: {
    id: 'middayBright',
    name: '☀️ タイムミッドデイブライト',
    description: '明るい昼間の活力とエネルギー',
    category: 'standard',
    colors: {
      primary: 'teal',        // より鮮やかなティール
      secondary: 'slate',
      accent: 'cyan',
      neutral: 'gray',
      // 背景色 - 鮮やかなターコイズ系
      background: 'teal-25',         // 薄いターコイズ背景
      cardBg: 'white',
      // テキスト色
      textPrimary: 'slate-800',
      textSecondary: 'slate-600',
      // ボーダー
      border: 'teal-300',            // より鮮やか
      borderLight: 'teal-200',
      // ボタン - 鮮やかなティール
      button: 'teal-500',
      buttonHover: 'teal-600',
      // ヘッダー（グロナビ）- 鮮やかな色
      headerBg: 'teal-500',
      headerText: 'white',
      headerHover: 'teal-400/20',
      // フッター - 深いティール
      footerBg: 'teal-700',
      footerText: 'white',
      footerLink: 'teal-200'
    }
  },

  // 🌇 イブニングウォーム - 夕方の温かみ（鮮やかなマゼンタ系）
  eveningWarm: {
    id: 'eveningWarm',
    name: '🌇 タイムイブニングウォーム',
    description: '夕暮れの温かみで心を落ち着ける',
    category: 'standard',
    colors: {
      primary: 'fuchsia',     // より鮮やかなフクシア
      secondary: 'slate',
      accent: 'rose',
      neutral: 'gray',
      // 背景色 - 鮮やかなマゼンタ系
      background: 'fuchsia-25',      // 薄いフクシア背景
      cardBg: 'white',
      // テキスト色
      textPrimary: 'slate-800',
      textSecondary: 'slate-600',
      // ボーダー
      border: 'fuchsia-300',         // より鮮やか
      borderLight: 'fuchsia-200',
      // ボタン - 鮮やかなフクシア
      button: 'fuchsia-500',
      buttonHover: 'fuchsia-600',
      // ヘッダー（グロナビ）- 鮮やかな色
      headerBg: 'fuchsia-500',
      headerText: 'white',
      headerHover: 'fuchsia-400/20',
      // フッター - 深いフクシア
      footerBg: 'fuchsia-700',
      footerText: 'white',
      footerLink: 'fuchsia-200'
    }
  },

  // 🌙 ナイトピース - 夜の静寂（鮮やかなインディゴ系）
  nightPeace: {
    id: 'nightPeace',
    name: '🌙 タイムナイトピース',
    description: '静かな夜の安らぎで深いリラックス',
    category: 'standard',
    colors: {
      primary: 'indigo',      // より鮮やかなインディゴ
      secondary: 'slate',
      accent: 'blue',
      neutral: 'gray',
      // 背景色 - 鮮やかなインディゴ系
      background: 'indigo-25',       // 薄いインディゴ背景
      cardBg: 'white',
      // テキスト色
      textPrimary: 'slate-800',
      textSecondary: 'slate-600',
      // ボーダー
      border: 'indigo-300',          // より鮮やか
      borderLight: 'indigo-200',
      // ボタン - 鮮やかなインディゴ
      button: 'indigo-500',
      buttonHover: 'indigo-600',
      // ヘッダー（グロナビ）- 鮮やかな色
      headerBg: 'indigo-600',
      headerText: 'white',
      headerHover: 'indigo-500/20',
      // フッター - 深いインディゴ
      footerBg: 'indigo-800',
      footerText: 'white',
      footerLink: 'indigo-200'
    }
  },

  // 💚 リラックス - 癒しのエメラルド系（ストレス軽減）
  relaxWellness: {
    id: 'relaxWellness',
    name: '💚 ウェルネスリラックス',
    description: 'ストレス軽減と心の癒しをサポート',
    category: 'standard',
    colors: {
      primary: 'emerald',     // 癒しのエメラルド
      secondary: 'slate',
      accent: 'green',
      neutral: 'gray',
      // 背景色 - 癒しのエメラルド系
      background: 'emerald-25',      // 薄いエメラルド背景
      cardBg: 'white',
      // テキスト色
      textPrimary: 'slate-800',
      textSecondary: 'slate-600',
      // ボーダー
      border: 'emerald-300',         // 鮮やかなエメラルド
      borderLight: 'emerald-200',
      // ボタン - 癒しのエメラルド
      button: 'emerald-500',
      buttonHover: 'emerald-600',
      // ヘッダー（グロナビ）- 鮮やかな色
      headerBg: 'emerald-500',
      headerText: 'white',
      headerHover: 'emerald-400/20',
      // フッター - 深いエメラルド
      footerBg: 'emerald-700',
      footerText: 'white',
      footerLink: 'emerald-200'
    }
  },

  // ⚡ エナジー - 活力のオレンジ系（やる気向上）
  energyWellness: {
    id: 'energyWellness',
    name: '⚡ ウェルネスエナジー',
    description: '活力とやる気を引き出すエネルギッシュなテーマ',
    category: 'standard',
    colors: {
      primary: 'orange',      // 読みやすいオレンジ
      secondary: 'slate',
      accent: 'amber',
      neutral: 'gray',
      // 背景色 - 活力のオレンジ系
      background: 'orange-25',       // 薄いオレンジ背景
      cardBg: 'white',
      // テキスト色 - より濃く
      textPrimary: 'slate-900',      // より濃い色で読みやすく
      textSecondary: 'slate-700',
      // ボーダー
      border: 'orange-300',          // 鮮やかなオレンジ
      borderLight: 'orange-200',
      // ボタン - 活力のオレンジ
      button: 'orange-500',
      buttonHover: 'orange-600',
      // ヘッダー（グロナビ）- 鮮やかな色
      headerBg: 'orange-500',
      headerText: 'white',
      headerHover: 'orange-400/20',
      // フッター - 深いオレンジ
      footerBg: 'orange-700',
      footerText: 'white',
      footerLink: 'orange-200'
    }
  },

  // 🧘 フォーカス - 集中のサファイア系（作業効率）
  focusWellness: {
    id: 'focusWellness',
    name: '🧘 ウェルネスフォーカス',
    description: '集中力と作業効率を高める落ち着いたテーマ',
    category: 'standard',
    colors: {
      primary: 'blue',        // 集中のブルー
      secondary: 'slate',
      accent: 'sky',
      neutral: 'gray',
      // 背景色 - 集中のブルー系
      background: 'blue-25',         // 薄いブルー背景
      cardBg: 'white',
      // テキスト色
      textPrimary: 'slate-800',
      textSecondary: 'slate-600',
      // ボーダー
      border: 'blue-300',            // 鮮やかなブルー
      borderLight: 'blue-200',
      // ボタン - 集中のブルー
      button: 'blue-500',
      buttonHover: 'blue-600',
      // ヘッダー（グロナビ）- 鮮やかな色
      headerBg: 'blue-500',
      headerText: 'white',
      headerHover: 'blue-400/20',
      // フッター - 深いブルー
      footerBg: 'blue-700',
      footerText: 'white',
      footerLink: 'blue-200'
    }
  },

  // ⚖️ バランス - 調和のアクア系（心の安定）
  balanceWellness: {
    id: 'balanceWellness',
    name: '⚖️ ウェルネスバランス',
    description: '心の安定と調和をもたらす穏やかなテーマ',
    category: 'standard',
    colors: {
      primary: 'cyan',        // 調和のシアン（アクア）
      secondary: 'slate',
      accent: 'sky',
      neutral: 'gray',
      // 背景色 - 調和のアクア系
      background: 'cyan-25',         // 薄いシアン背景
      cardBg: 'white',
      // テキスト色
      textPrimary: 'slate-800',
      textSecondary: 'slate-600',
      // ボーダー
      border: 'cyan-300',            // 鮮やかなシアン
      borderLight: 'cyan-200',
      // ボタン - 調和のシアン
      button: 'cyan-500',
      buttonHover: 'cyan-600',
      // ヘッダー（グロナビ）- 鮮やかな色
      headerBg: 'cyan-500',
      headerText: 'white',
      headerHover: 'cyan-400/20',
      // フッター - 深いシアン
      footerBg: 'cyan-700',
      footerText: 'white',
      footerLink: 'cyan-200'
    }
  },

  // =================================
  // プレミアムプラン専用テーマ（スタンダードベース + 高級装飾）
  // =================================

  // 💎 エグゼクティブ - スタンダードベース + エレガントな青系
  premiumExecutive: {
    id: 'premiumExecutive',
    name: '💎 プレミアムエグゼクティブ',
    description: '企業重役クラスの高級感溢れるエレガントブルーテーマ',
    category: 'premium',
    colors: {
      primary: 'slate',        // エグゼクティブなスレート
      secondary: 'blue',
      accent: 'indigo',        // 深いインディゴアクセント
      neutral: 'gray',
      // 背景色 - 上品な薄いブルー系
      background: 'slate-50',  // 薄いスレート背景
      cardBg: 'white',
      // テキスト色
      textPrimary: 'slate-900',
      textSecondary: 'slate-700',
      // ボーダー
      border: 'slate-300',
      borderLight: 'slate-200',
      // ボタン - ラグジュアリーなブルー
      button: 'blue-600',
      buttonHover: 'blue-700',
      // ヘッダー（グロナビ）- 深いスレート
      headerBg: 'slate-700',
      headerText: 'white',
      headerHover: 'slate-600/20',
      // フッター - より深いスレート
      footerBg: 'slate-800',
      footerText: 'white',
      footerLink: 'blue-300'
    }
  },

  // 👑 ロイヤル - スタンダードベース + 王室風の金色
  premiumRoyal: {
    id: 'premiumRoyal',
    name: '👑 プレミアムロイヤル',
    description: '王室のような格式高い金色の最高級テーマ',
    category: 'premium',
    colors: {
      primary: 'amber',        // 王室の金色
      secondary: 'yellow',
      accent: 'orange',        // 暖かみのあるアクセント
      neutral: 'stone',
      // 背景色 - 上品な金色系
      background: 'amber-50',  // 上品な薄い金色
      cardBg: 'white',
      // テキスト色
      textPrimary: 'amber-900',
      textSecondary: 'amber-700',
      // ボーダー
      border: 'amber-300',
      borderLight: 'amber-200',
      // ボタン - ロイヤルゴールド
      button: 'amber-600',
      buttonHover: 'amber-700',
      // ヘッダー（グロナビ）- 深い金色
      headerBg: 'amber-700',
      headerText: 'white',
      headerHover: 'amber-600/20',
      // フッター - より深い金色
      footerBg: 'amber-800',
      footerText: 'white',
      footerLink: 'amber-200'
    }
  },

  // 🌟 プラチナ - スタンダードベース + 白金のような洗練
  premiumPlatinum: {
    id: 'premiumPlatinum',
    name: '🌟 プレミアムプラチナ',
    description: 'プラチナのような洗練された上品なテーマ',
    category: 'premium',
    colors: {
      primary: 'zinc',         // プラチナのような色
      secondary: 'slate',
      accent: 'violet',        // エレガントなアクセント
      neutral: 'gray',
      // 背景色 - 上品なプラチナ系
      background: 'zinc-50',   // 薄いプラチナ色
      cardBg: 'white',
      // テキスト色
      textPrimary: 'zinc-900',
      textSecondary: 'zinc-700',
      // ボーダー
      border: 'zinc-300',
      borderLight: 'zinc-200',
      // ボタン - エレガントなバイオレット
      button: 'violet-600',
      buttonHover: 'violet-700',
      // ヘッダー（グロナビ）- 深いプラチナ
      headerBg: 'zinc-700',
      headerText: 'white',
      headerHover: 'zinc-600/20',
      // フッター - より深いプラチナ
      footerBg: 'zinc-800',
      footerText: 'white',
      footerLink: 'violet-300'
    }
  },

  // 💜 ラグジュアリー - スタンダードベース + 贅沢な紫
  premiumLuxury: {
    id: 'premiumLuxury',
    name: '💜 プレミアムラグジュアリー',
    description: '贅沢で上品な紫色の高級テーマ',
    category: 'premium',
    colors: {
      primary: 'purple',       // ラグジュアリーパープル
      secondary: 'violet',
      accent: 'fuchsia',       // 華やかなアクセント
      neutral: 'slate',
      // 背景色 - エレガントな紫系
      background: 'purple-50', // 薄い紫色
      cardBg: 'white',
      // テキスト色
      textPrimary: 'purple-900',
      textSecondary: 'purple-700',
      // ボーダー
      border: 'purple-300',
      borderLight: 'purple-200',
      // ボタン - ラグジュアリーパープル
      button: 'purple-600',
      buttonHover: 'purple-700',
      // ヘッダー（グロナビ）- 深い紫
      headerBg: 'purple-700',
      headerText: 'white',
      headerHover: 'purple-600/20',
      // フッター - より深い紫
      footerBg: 'purple-800',
      footerText: 'white',
      footerLink: 'fuchsia-300'
    }
  }
};

// 基本テーマのヘルパー関数をベースにした生成関数
export const generateStandardThemeClasses = (theme) => {
  if (!theme || !theme.colors) {
    return generateStandardThemeClasses(standardThemes.morningCalm); // デフォルト
  }

  const colors = theme.colors;
  
  return {
    // 背景 - 基本テーマと同じ
    bg: `bg-${colors.background}`,
    bgCard: `bg-${colors.cardBg}`,
    background: `bg-${colors.background}`,
    pageBackground: `bg-${colors.background}`,
    
    // テキスト - 基本テーマと同じ
    textPrimary: `text-${colors.textPrimary}`,
    textSecondary: `text-${colors.textSecondary}`,
    
    // ボーダー - 基本テーマと同じ
    border: `border-${colors.border}`,
    borderLight: `border-${colors.borderLight}`,
    
    // ボタン - プレミアムテーマは濃い色を使用
    primaryButton: theme.category === 'premium' 
      ? `bg-${colors.button} hover:bg-${colors.buttonHover} text-white font-semibold shadow-lg hover:shadow-xl base-button`
      : `bg-${colors.button} hover:bg-${colors.buttonHover} text-white base-button`,
    secondaryButton: theme.category === 'premium'
      ? `bg-${colors.neutral}-200 hover:bg-${colors.neutral}-300 text-${colors.neutral}-900 font-medium base-button`
      : `bg-${colors.neutral}-100 hover:bg-${colors.neutral}-200 text-${colors.neutral}-800 base-button`,
    button: theme.category === 'premium'
      ? `bg-${colors.button} hover:bg-${colors.buttonHover} text-white font-semibold shadow-lg hover:shadow-xl base-button`
      : `bg-${colors.button} hover:bg-${colors.buttonHover} text-white base-button`,
    buttonSecondary: theme.category === 'premium'
      ? `bg-${colors.neutral}-200 hover:bg-${colors.neutral}-300 text-${colors.neutral}-900 font-medium base-button`
      : `bg-${colors.neutral}-100 hover:bg-${colors.neutral}-200 text-${colors.neutral}-800 base-button`,
    
    // カード - プレミアムテーマは濃い背景
    card: theme.category === 'premium' ? `premium-card standard-card` : `standard-card`,
    cardHeader: theme.category === 'premium'
      ? `bg-gradient-to-r from-${colors.primary}-100 to-${colors.accent}-100 border-b border-${colors.borderLight}`
      : `bg-gradient-to-r from-${colors.primary}-50 to-${colors.accent}-50 border-b border-${colors.borderLight}`,
    
    // スタンダード専用効果
    standardEffect: getStandardEffectClass(theme.id),
    premiumEffect: '', // プレミアム用は空
    
    // アクセントカラー - 基本テーマと同じ
    accent: `text-${colors.accent}-600`,
    accentBg: `bg-${colors.accent}-100`,
    
    // ヘッダー（グロナビ）- スタンダードは色付き
    header: `bg-${colors.headerBg} text-${colors.headerText}`,
    headerBg: `bg-${colors.headerBg}`,
    headerText: `text-${colors.headerText}`,
    navLink: `text-${colors.headerText} hover:bg-${colors.headerHover}`,
    
    // フッター - スタンダードは色付き
    footer: `bg-${colors.footerBg} text-${colors.footerText}`,
    footerBg: `bg-${colors.footerBg}`,
    footerText: `text-${colors.footerText}`,
    footerLink: `text-${colors.footerLink} hover:text-${colors.footerText}`,
    
    // リンク - スタンダード専用装飾
    link: `text-${colors.primary}-600 hover:text-${colors.primary}-800 base-link`,
    
    // 入力フィールド - スタンダード専用装飾
    input: `border-${colors.border} focus:border-${colors.primary}-500 focus:ring-${colors.primary}-500 base-input`,
    
    // 成功・エラーなどの状態色（共通）
    success: 'text-green-600 bg-green-50 border-green-200',
    warning: 'text-yellow-600 bg-yellow-50 border-yellow-200',
    error: 'text-red-600 bg-red-50 border-red-200',
    info: `text-${colors.primary}-600 bg-${colors.primary}-50 border-${colors.primary}-200`
  };
};

// スタンダードテーマ別エフェクトクラス
export const getStandardEffectClass = (themeId) => {
  switch (themeId) {
    case 'morningCalm':
      return 'standard-morning-theme';
    case 'middayBright':
      return 'standard-midday-theme';
    case 'eveningWarm':
      return 'standard-evening-theme';
    case 'nightPeace':
      return 'standard-night-theme';
    case 'relaxWellness':
      return 'standard-relax-theme';
    case 'energyWellness':
      return 'standard-energy-theme';
    case 'focusWellness':
      return 'standard-focus-theme';
    case 'balanceWellness':
      return 'standard-balance-theme';
    // プレミアムテーマ
    case 'premiumExecutive':
      return 'premium-executive-theme';
    case 'premiumRoyal':
      return 'premium-royal-theme';
    case 'premiumPlatinum':
      return 'premium-platinum-theme';
    case 'premiumLuxury':
      return 'premium-luxury-theme';
    default:
      return '';
  }
};

// CSS変数設定（テーマの色をRGB値で設定）
export const setStandardThemeCSSVars = (theme) => {
  const root = document.documentElement;
  
  // プライマリカラーのRGB値を取得
  const primaryRGB = getTailwindColorRGB(theme.colors.primary);
  const accentRGB = getTailwindColorRGB(theme.colors.accent);
  
  root.style.setProperty('--theme-primary-rgb', primaryRGB);
  root.style.setProperty('--theme-accent-rgb', accentRGB);
};

// Tailwindカラー名からRGB値を取得するヘルパー
const getTailwindColorRGB = (colorName) => {
  const colorMap = {
    // スタンダードテーマの鮮やかな色
    'red': '239, 68, 68',         // 鮮やかなレッド（コーラル）
    'pink': '236, 72, 153',       // ピンクアクセント
    'teal': '20, 184, 166',       // 鮮やかなティール（ターコイズ）
    'cyan': '6, 182, 212',        // シアンアクセント
    'fuchsia': '217, 70, 239',    // 鮮やかなフクシア（マゼンタ）
    'rose': '244, 63, 94',        // ローズアクセント
    'indigo': '99, 102, 241',     // 鮮やかなインディゴ
    'blue': '59, 130, 246',       // ブルーアクセント
    
    // ウェルネステーマの色
    'emerald': '16, 185, 129',    // 癒しのエメラルド
    'green': '34, 197, 94',       // グリーンアクセント
    'orange': '249, 115, 22',     // 活力のオレンジ（読みやすく調整）
    'amber': '245, 158, 11',      // アンバーアクセント
    'violet': '139, 92, 246',     // バイオレットアクセント
    
    // プレミアムテーマの色
    'slate': '71, 85, 105',       // エグゼクティブなスレート
    'zinc': '113, 113, 122',      // プラチナのような色
    'purple': '147, 51, 234',     // ラグジュアリーパープル
    
    // 基本色（フォールバック用）
    'sky': '14, 165, 233',
  };
  return colorMap[colorName] || '59, 130, 246'; // デフォルトはブルー
};